import React, { useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import Logo from '../../../assets/images/logo/Haylo-logo-white.png'
import { Link, useHistory } from 'react-router-dom'
import Layout from '../../../components/layouts/Layout'
import classNames from 'classnames'
import http from '../../../config/BaseUrl'

const PasswordChange = () => {

  const history = useHistory();
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState("")
  const { register, handleSubmit, watch, reset, formState: { errors } } = useForm({ mode: 'all', reValidateMode: "onChange" })

  const password = useRef({});
  password.current = watch("password", "");

console.log(message);

  const handelChangePassword = async (data) => {
       
        try {
            await http.post('/password-change', data).then((res) => {
              if (res.data) {
                setMessage(res.data.message);
                reset()
              }
            })
        } catch (error) {
          
        }
  }

  return (
    <Layout>
      <div className="p-3 bg-white">
        <div className="px-0 container-fluid">

          <div className="row">

            <div className="col-md-6 d-none d-md-block">
              <div className="page-image" style={{height:'75vh'}}>
                <div className="mt-5 login-header">
                  <div className="logo">
                    <img src={Logo} className="img-fluid" alt="haylo" />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-12">
              <div className="form-body"  style={{height:'56vh'}}>
                <div className="row justify-content-center align-items-end h-100">
                  <div className="col-md-7 col-sm-8 col-12">
                    <div className="mx-auto my-auto h-100">
                      <div className="p-md-3">
                        <div className="text-left">
                          <h3 className="mb-4 font-weight-bold">Change Password</h3>
                        </div>
                        <div className="text-left">
                          {message ? (
                            <div class="alert alert-success alert-dismissible fade show" role="alert">{message}
                              <button type="button" class="close" data-dismiss="alert" aria-label="Close">	<span aria-hidden="true">×</span>
                              </button>
                            </div>
                          ) : ("")}
                        </div>
                        <form onSubmit={handleSubmit(handelChangePassword)}>
                          <div className="form-group">
                            <label htmFor="forgotEmail">Old Password </label>
                            <input
                              type="Old Password"
                              id="OldPassword"
                              className={classNames("form-control", {"is-invalid":errors.old_password})}
                              placeholder="Enter Old Password"
                              {...register('old_password', {
                                required: "This field is required"
                              })}
                            />
                            <span className="text-danger font-size-14">{errors.old_password && errors.old_password.message}</span>
                          </div>
                          <div className="form-group">
                            <label htmFor="forgotEmail">Password </label>
                            <input
                              type="password"
                              id="Password"
                              className={classNames("form-control", {"is-invalid":errors.password})}
                              placeholder="Enter Password"
                              {...register('password', {
                                required: "This field is required"
                              })}
                            />
                             <span className="text-danger text-danger font-size-14">{errors.password && errors.password.message}</span>
                            </div>
                          <div className="form-group">
                            <label htmFor="forgotEmail">Confirm Password </label>
                            <input
                              type="password"
                              id="confirmPassword"
                              className={classNames("form-control", {"is-invalid":errors.password_confirmation})}
                              placeholder="Enter Password Confirm"
                              {...register("password_confirmation", {
                                validate: value =>
                                  value === password.current || "The passwords do not match"
                              })}
                            />
                            </div>


                          <div className="mt-3 btn-group w-100">
                            <button type="submit" className="btn btn-primary btn-block">
                              {loading && loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>)
                                : ("Change Password ")
                              }
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>

      </div>

    </Layout>
  )
}

export default PasswordChange
